'use strict'

import { forEach } from 'lodash';

import { subscribe } from '../../01-helpers/event-manager';
import { PILL_REMOVED } from '../../02-const/event-names';

import FilterInput from '../../04-components/filtering/filter-input';

const moduleName = 'filter-checkbox',
	selectors = {
		base: `.js-${moduleName}`,
		value: `.js-${moduleName}-value`
	},
	attributeNames = {
		dataRefresh: 'data-refresh'
	};

export default class FilterCheckbox extends FilterInput {

	constructor(baseElement) {
		super(baseElement);
		this.input = this.baseElement.querySelector('input');
		this._subscribeEvents();
	}

	/**
	 *
	 *
	 **/
	_uncheckFilter(event) {
		const filterId = event?.detail?.id,
			refresh = this.input.getAttribute(attributeNames.dataRefresh);

		if (filterId === undefined || this.input.id != filterId) {
			return false;
		}

		// if filterId is current input value then uncheck filter
		this.input.checked = false;
		this.filterContext.update(
			{
				NodeId: this.NodeId,
				Page: this.Page,
				Filters: this._updateFilterContext(this.input)
			},
			{ refresh: refresh === 'true' }
		);

		this._setPush('filter_remove', this.key, this.input.name, 'Remove', `${this.input.name}|${this.key}`);
	}

	_subscribeEvents() {
		subscribe(PILL_REMOVED, (event) => this._uncheckFilter(event));
	}
}

/* ========================================================================== */

const initFilterCheckbox = () => {
	forEach(document.querySelectorAll(selectors.base), (selectionElement) => {
		new FilterCheckbox(selectionElement);
	});
};

initFilterCheckbox();
